//+++++++++++++++++++++++++++++++++++++++++++++++
// HELPERS
//+++++++++++++++++++++++++++++++++++++++++++++++
// Small js functions and enhancements, that
// make dealing with cross browser functionality
// easier.
//+++++++++++++++++++++++++++++++++++++++++++++++

// Self Explanatory
export const isTouchDevice = () => 'ontouchstart' in document.documentElement;

export function getMainHeaderHeight() {
    const mainHeader = document.querySelector('.main-header');
    if (mainHeader) {
        return mainHeader.getBoundingClientRect().height;
    }

    return 0;
}

export function toTop(ev) {
    ev.preventDefault();
    document.getElementById('header').scrollIntoView({behavior: 'smooth'});
}

export function getButtonVisibleClass() {
    return 'btn--visible';
}

export function getVendorPrefix(arrayOfPrefixes) {
    const tmp = document.createElement("div");
    for (let i = 0; i < arrayOfPrefixes.length; i++) {
        if (tmp.style[arrayOfPrefixes[i]] !== 'undefined') {
            return arrayOfPrefixes[i];
        }
    }

    return false;
}


// WEBPACK FOOTER //
// ./wp-content/themes/template/js/src/Modules/Helper.js